import React from "react"

import { Element } from "legacy/components/shared/base"
import { ControlButton } from "./ControlButton"

export type CarouselControlsProps = {
  changeSlide: (setCurrentSlideIndex: number) => void
  currentSlideIndex: number
  length: number
}

export const Controls: React.FC<CarouselControlsProps> = ({
  changeSlide,
  currentSlideIndex,
  length,
}): React.ReactElement | null => {
  return (
    <Element mb={["sm", "0"]}>
      <ControlButton
        buttonAction="previous"
        onButtonClick={() =>
          changeSlide(
            currentSlideIndex === 0 ? currentSlideIndex : currentSlideIndex - 1
          )
        }
      />
      <ControlButton
        buttonAction="next"
        onButtonClick={() =>
          changeSlide(
            currentSlideIndex === length - 1
              ? currentSlideIndex
              : currentSlideIndex + 1
          )
        }
      />
    </Element>
  )
}
